import { LegacyRef, forwardRef } from 'react';
import cx from 'classnames/bind';

import { getWordWithEnding } from '@/utils/getWordWithEnding';

import styles from './Notification.module.scss';

interface NotificationProps {
  points?: number;
  text?: string;
  className?: string;
}

const cn = cx.bind(styles);

const Notification = forwardRef(
  (
    { points, text, className }: NotificationProps,
    ref?: LegacyRef<HTMLDivElement>,
  ) => (
    <div ref={ref} className={cn('points', className)}>
      {text && <span>{text}</span>}
      {points && (
        <>
          + {points}{' '}
          <span>{getWordWithEnding(points, ['балл', 'балла', 'баллов'])}</span>
        </>
      )}
    </div>
  ),
);

export default Notification;
